import { ProtectedRoute } from 'containers/Authentication';
import React from 'react';
import { Switch } from 'react-router-dom';

import RemoteLayouts from './RemoteLayouts';
import AdSlotFlows from './AdSlotFlows';
import AdsureMonitoring from 'containers/AdsureMonitoring';
import UserGuideManagementPage from 'features/userGuide/pages/UserGuideManagementPage';
import UserFeedbackManagementPage from 'features/userFeedback/pages/UserFeedbackManagementPage';
import AdminCenterLayout from './AdminCenterLayout';
import ApplicationCredentialManagementPage from './ApplicationCredentialManagementPage';
import PodManagementPage from './PodManagementPage';

function AdminPage() {
  return (
    <AdminCenterLayout>
      <Switch>
        <ProtectedRoute path="/admin/monitoring" component={AdsureMonitoring} />
        <ProtectedRoute
          path="/admin/user-guide"
          component={UserGuideManagementPage}
        />
        <ProtectedRoute
          path="/admin/user-feedback"
          component={UserFeedbackManagementPage}
        />
        <ProtectedRoute
          path="/admin/application-credentials"
          component={ApplicationCredentialManagementPage}
        />
        <ProtectedRoute
          path="/admin/pod-management"
          component={PodManagementPage}
        />
        <ProtectedRoute
          path="/admin/remote-layouts"
          component={RemoteLayouts}
        />
        <ProtectedRoute path="/admin/adslot-flows" component={AdSlotFlows} />
      </Switch>
    </AdminCenterLayout>
  );
}

export default AdminPage;
